import client from '@/api/client.js';
import store from "@/store";
import i18n from '@/plugins/i18n.js'

export default {
    methods: {
        async getContractMap() {
            var meta = { clientApiMethod: 'getContractMap', input: {} }
            var response = await client().get(store.state.apiRouteRoot + "Contract/Map", { meta: meta })
            return response?.data;
        },

        async getContractListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getContractListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Contract/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },

        async getContractById(contractId) {
            var meta = { clientApiMethod: 'getContractById', input: { contractId: contractId } }
            var response = await client().get(store.state.apiRouteRoot + "Contract/" + contractId, { meta: meta })
            return response?.data;
        },

        async createContract(newContract) {
            var meta = {
                clientApiMethod: 'createContract',
                input: { newContract },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.contract.contract") })
            }
            var response = await client().put(store.state.apiRouteRoot + 'Contract', newContract, { meta: meta })
            return response?.data;
        },

        async changeContract(updatedContract) {
            var meta = {
                clientApiMethod: 'changeContract',
                input: { updatedContract },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.contract.contract") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'Contract', updatedContract, { meta: meta })
            return response?.data;
        },

        async deleteContract(contractId) {
            var meta = {
                clientApiMethod: 'deleteContract',
                input: { contractId: contractId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.contract.contract") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "Contract/" + contractId, { meta: meta })
            return response?.data;
        },


        async getContractActiveById(id) {
            var meta = {
                clientApiMethod: 'getContractActiveById',
                input: { id }
            }
            var response = await client().get(store.state.apiRouteRoot + "Contract/" + id + "/GetActiveState", { meta: meta })
            return response?.data;
        },
        async toggleContractActiveById(id) {
            var meta = {
                clientApiMethod: 'toggleContractActiveById',
                input: { id },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.customer.customer") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "Contract/" + id + "/ToggleActiveState", null, { meta: meta })
            return response?.data;
        },
        async getNextOrderContractsOverview(date) {
            var meta = { clientApiMethod: 'getNextOrderContractsOverview', input: { date } };
            var response = await client().get(
                store.state.apiRouteRoot + "ContractOrders/NextOrderContractsOverview",
                { params: { date: date }, meta: meta }
            );
            return response?.data;
        },
        async getNextContractOrderDraftByContractId(id, date) {
            var meta = { clientApiMethod: 'getNextContractOrderDraftByContractId', input: { id, date } };
            var response = await client().get(
                store.state.apiRouteRoot + "ContractOrders/Contract/" + id + "/NextOrderDraft",
                { params: { date: date }, meta: meta }
            );
            return response?.data;
        },
        async generateNextContractOrderByContractId(id, date) {
            var meta = { clientApiMethod: 'getNextContractOrderDraftByContractId', input: { id, date } };
            var response = await client().post(
                store.state.apiRouteRoot + "ContractOrders/Contract/" + id + "/GenerateNextOrder",
                { params: { date: date }, meta: meta }
            );
            return response?.data;
        },

        async generateContractOrdersFromPaymentPlans(paymentPlanIds) {
            var meta = { clientApiMethod: 'generateContractOrdersFromPaymentPlans', input: { paymentPlanIds } };
            var response = await client().post(
                store.state.apiRouteRoot + "ContractOrders/GenerateOrderFromPaymentPlans",
                { PaymentPlanIds: paymentPlanIds }, { meta: meta }
            );
            return response?.data;
        },
        async unlockPaymentPlanForOrderGeneration(paymentPlanIds) {
            var meta = {
                clientApiMethod: 'unlockPaymentPlanForOrderGeneration', input: { paymentPlanId: paymentPlanIds },
                successText: "Unlocked payment plan for order generation."
            };
            var response = await client().post(
                store.state.apiRouteRoot + "ContractOrders/UnlockPaymentPlanForOrderGeneration/",
                { PaymentPlanIds: paymentPlanIds }, { meta: meta }
            );
            return response?.data;
        },
        async getPastContractOrdersByContractId(id) {
            var meta = { clientApiMethod: 'getPastContractOrdersByContractId', input: { id } };
            var response = await client().get(store.state.apiRouteRoot + "ContractOrders/Contract/" + id, { meta: meta })
            return response?.data;
        },
    }
}